<template>
    <div class="add-partner" :class="{'not-inline' : !isInline}">
        <h3 v-if="isInline" data-number="2" class="title">Add individual creators</h3>
        <Form :schema="schema" @submit="submit" :values="values" v-slot="{ errors, success }" class="form-wrap" :class="[{'is-loading': is_loading}, {'is-error': is_error}]" :is_disabled="$store.state.is_loading || $store.state.current_creator_count >= $store.state.creator_max_count">
            <div class="two-field">
                <div class="item">
                    <label class="label">First name</label>
                    <el-input v-model="values.first_name" placeholder="First name" :class="[errors.first_name && 'err-input']"></el-input>
                    <p class="error-msg" v-if="errors.first_name">{{ errors.first_name }}<svg-icon name="alert"/></p>
                </div>
                <div class="item">
                    <label class="label">Last name</label>
                    <el-input v-model="values.last_name" placeholder="Last name" :class="[errors.last_name && 'err-input']"></el-input>
                    <p class="error-msg" v-if="errors.last_name">{{ errors.last_name }}<svg-icon name="alert"/></p>
                </div>
            </div>
            <!-- <label class="label">Creator social profiles</label>
            <p class="desc">This is used to authorize the creator's storefront.</p> -->
            <div class="one-field">
                <label class="label">Account authentication</label>
                <p class="desc">Please provide an email and/or social handle(s) which we will use to authorize the creator's storefront.</p>
                <label class="label-sub">Email</label>
                <el-input v-model="values.email" placeholder="Enter a valid email" :class="[(errors.email|| back_error_mag.email) && 'err-input']"/>
                <p class="error-msg" v-if="errors.email || back_error_mag.email">{{ errors.email || back_error_mag.email}}<svg-icon name="alert"/></p>
            </div>
            <div class="one-field">
                <label class="label-sub">Social handle</label>
                <el-input v-model="values.tiktok_handle" placeholder="@username" :class="[(errors.tiktok_handle || back_error_mag.tiktok_handle) && 'err-input']">
                    <template #prefix>www.TikTok.com/</template>
                </el-input>
                <el-input v-model="values.instagram_handle" placeholder="username" :class="[(errors.instagram_handle|| back_error_mag.instagram_handle) && 'err-input']">
                    <template #prefix>www.Instagram.com/</template>
                </el-input>
                <p v-if="error_msg" v-html="error_msg" class="error-msg"></p>
                <p v-else-if="back_error_mag.tiktok_handle || back_error_mag.instagram_handle" class="error-msg">{{ back_error_mag.tiktok_handle || back_error_mag.instagram_handle}}<svg-icon name="alert"/></p>
            </div>
            <!-- tag -->
            <div class="coll-chec program-tag-box-big">
                <label class="label">Tag</label>
                <dl class="tag-line program-tag-box">
                    <dd :class="['program-tag-box-dd','edit-program-tag-box-dd']"  >
                        <div @click.stop="values.tag_open= !values.tag_open; values.tag_all_open=false;" class="add-tag-btn" ><svg-icon name="tag-plus" /></div>
                        
                        <Badage class="tag-item-box" v-for="(v,k) in values.merchant_account_tags.filter((ee,kk)=>{return kk < 8 })" :key="k" :value="v.text" :show_tippy="true">
                            <svg-icon name="close" @click.stop="handleSelectTag({tag:v, row:values },'from_outside')" />
                        </Badage >
                        <Badage @click.stop="values.tag_all_open= !values.tag_all_open; values.tag_open=false;" v-if="values.merchant_account_tags.length - 8 > 0" :value="`+${ values.merchant_account_tags.length - 5}`"></Badage>
                    </dd>
                </dl>
                <!-- 開關tag_open -->
                <DropdownHashtag :tags="values.tags" :selected_tags="values.merchant_account_tags"
                    :tag_type="'creator_tag'"
                    @select-tag="selectTag"
                    @closeKey="values.tag_open=false"                          
                    :open_key="values.tag_open"
                    :row="values"
                    :drop_css="'top:unset;left:0px;bottom:36px'"
                    :index="9999"
                    :is_adding="true"
                    />
                <!-- 開關tag_all_open -->
                <HashtagPopup 
                    :tags="values.merchant_account_tags"
                    :row="values" 
                    :open_key="values.tag_all_open"
                    :drop_css="'top:unset;left:0px;bottom:36px'"
                    :index="9999"
                    @closeKey="values.tag_all_open=false;"
                    @open-cre-tag="values.tag_open=true;values.tag_all_open=false;"
                />
            </div>
            <div class="btn-wrap">
                <p v-if="$store.state.user_data.merchant_account && !$store.state.is_loading && $store.state.current_creator_count >= $store.state.creator_max_count">Creator limit reached. 
                    <!-- <router-link :to="'/help'"> Contact us to upgrade.</router-link> -->
                    <a :href="`mailto:${$store.state.mail_to}?subject=${$store.state.user_data.merchant_account.merchant_display_name} - Upgrade creator limit&body=Please provide your name and contact info. A representative will contact you in 1-2 business days.`" target="_blank">Contact us to upgrade.</a>
                </p>
                <Button type="submit" color="dark-blue" size="32" :is_disabled="$store.state.is_loading || $store.state.current_creator_count >= $store.state.creator_max_count">Add</Button>
            </div>
            
        </Form>
        <p class="or">or</p>
        <div class="form-wrap upload-form" :class="{'is-loading': is_loading ,'disabeld-box':$store.state.merchant_disabeld }">
            <div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active">
                <h3>Drop files to upload</h3>
            </div>
            <FileUpload v-show="!files.length"
                :extensions="'xlsx,xls,csv'"
                :accept="'.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'"
                :multiple="false"
                :directory="false"
                :create-directory="false"
                :thread="3 < 1 ? 1 : (3 > 5 ? 5 : 3)"
                :drop="true"
                :add-index="false"
                v-model="files"
                ref="upload">
                <div class="empty-box">
                    <!-- <img src="@/assets/images/waiting.png" /> -->
                    <SvgIcon name="upload" />
                    <p>Drag and drop your CSV file here or <a>click to import</a><br/>
                        <span class="desc">Upload a .csv file. (Max. size: 5mb.)</span>
                    </p>
                </div>
            </FileUpload>

            <div class="file-list" v-if="files.length">
                <div class="item" v-for="(file, index) in files" :key="file.id">
                    <div class="ico">
                        <img src="@/assets/images/csv.png" />
                    </div>
                    <div class="meta">
                        <h3 class="name">{{ file.name }}</h3>
                        <p class="size">{{ formatBytes(file.size, 0) }}</p>
                    </div>
                    <div class="remove" @click="files = []">
                        <SvgIcon name="close-circle" />
                    </div>
                </div>
            </div>
            <div class="btn-wrap">
                <Button v-if="!files.length" :style="'border'" color="dark-blue" size="32" :to="[`${$DownloasUrl}/examples/creator_upload_template.xlsx`]" download :is_external="true">
                    <SvgIcon name="file" />Download Excel template
                </Button>
                <Button v-else 
                    type="button" 
                    color="dark-blue" 
                    size="32"
                    @click.native="uploadFile"
                >Upload</Button>
            </div>
        </div>
        <Modal :is_show="is_show_progress" class="progress-modal">
            <div class="box" v-if="files.length !== 0">
                <p v-if="is_file_error"><span class="error-text" v-html="file_error_msg"></span></p>
                <div class="btn" v-if="is_file_error">
                    <Button type="button" :style="'border'" color="dark-blue" size="32" @click.native="cancelUpload">Close</Button>
                </div>
                <p v-else-if="Number(progress) === 100">
                    <strong>Creator data imported.</strong>
                    <br> Click "Done" below to review information and confirm.
                </p>
                <p v-else>
                    <strong>Processing creator data...</strong>
                    <br> Please do not close this window.
                </p>
                <div v-for="(file, index) in files" :key="file.id" v-if="!is_file_error">
                    <div class="progress">
                        <div :class="{'progress-bar': true, 'progress-bar-striped': true, 'bg-danger': file.error, 'progress-bar-animated': file.active}" role="progressbar" :style="{width: progress + '%'}">
                        </div>
                    </div>

                    <div class="btn">
                        <span class="text">{{progress}}%</span>
                        <Button v-if="Number(progress) === 100" type="button" color="dark-blue" size="32" @click="doneUpload">Done</Button>
                        <Button v-else type="button" :style="'border'" color="dark-blue" size="32" @click.native="cancelUpload">Cancel</Button>
                    </div>
                </div>
            </div>
        </Modal>

    </div>



</template>

<script>
import FileUpload from 'vue-upload-component';
import SvgIcon from '@/components/ui/SvgIcon.vue';
import Field from '@/components/ui/Field.vue';
import Form from '@/components/ui/Form.vue';
import formatBytes from '@/utils/formatBytes';
import Button from '@/components/ui/Button.vue';
import Modal from '@/components/ui/Modal.vue';
import Badage from '@/components/ui/Badage.vue';
import HashtagPopup from '@/components/HashtagPopup.vue';
import DropdownHashtag from '@/components/DropdownHashtag.vue';
import { getTags, handleCreTag ,selectTag,editOrDelCreTag } from '@/utils/CreatorTagFun';
import { ElInput, ElSelect, ElButton, ElLoading, ElDialog } from 'element-plus';

// import * as XLSX from 'xlsx';
import * as yup from 'yup'; 

export default {
    name: 'add-partner',

    components: {
        SvgIcon,
        FileUpload,
        Field,
        Button,
        Form,
        Modal,
        Badage,
        DropdownHashtag,
        HashtagPopup,
        ElInput,
    },

    data() {
        return {
            is_loading: false,
            is_error: false,
            interval: null,
            progress: 0,
            error_msg: '',
            is_file_error: false,
            file_error_msg: '',
            upload_data: {},

            values: {
                first_name: '',
                last_name: '',
                tiktok_handle: '',
                instagram_handle: '',
                email:'',
                merchant_account_tags:[],
                tags:[],
                tag_open:false,
                tag_all_open:false,
            },

            schema: yup.object().shape({
                first_name: yup.string().required('Cannot leave blank.'),
                last_name: yup.string().required('Cannot leave blank.'),
                email:yup.string()
                .test(
                    'is-valid-email',
                    'Invalid email address.',
                    (value) => 
                        !value || /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{1,}$/.test(value)
                ).notRequired(),
                instagram_handle: yup.string()
                    .max(30, 'Your handle can\'t exceed 30 characters')
                    .matches(
                        /(^$)|^[aA-zZ0-9_.]+$/,
                        `Invalid social handle`
                    ).notRequired(),
                tiktok_handle: yup.string()
                    .max(30, 'Your handle can\'t exceed 30 characters')
                    .matches(
                        /(^$)|^[@][aA-zZ0-9_.]+$|^[aA-zZ0-9_.]+$/,
                        `Invalid social handle`
                    ).notRequired(),
            }).test(
                'at-least-one',
                'You must fill at least one of email, instagram_handle, or tiktok_handle.',
                function (values) {
                    const { email, instagram_handle, tiktok_handle } = values || {};
                    const errors = [];

                    // 检查是否至少填写了一个字段
                    if (!email && !instagram_handle && !tiktok_handle) {
                    errors.push(
                        this.createError({
                        path: 'email',
                        message: 'Cannot leave blank.',
                        }),
                        this.createError({
                        path: 'instagram_handle',
                        message: 'Cannot leave blank.',
                        }),
                        this.createError({
                        path: 'tiktok_handle',
                        message: 'Cannot leave blank.',
                        })
                    );
                    }

                    // 检查单独字段的规则
                    if (email && !this.schema.fields.email.isValidSync(email)) {
                    errors.push(
                        this.createError({ path: 'email', message: 'Invalid email address.' })
                    );
                    }
                    if (instagram_handle && !this.schema.fields.instagram_handle.isValidSync(instagram_handle)) {
                    errors.push(
                        this.createError({ path: 'instagram_handle', message: 'Invalid social handle.' })
                    );
                    }
                    if (tiktok_handle && !this.schema.fields.tiktok_handle.isValidSync(tiktok_handle)) {
                    errors.push(
                        this.createError({ path: 'tiktok_handle', message: 'Invalid social handle.' })
                    );
                    }

                    // 如果有任何错误，则抛出
                    if (errors.length) throw new yup.ValidationError(errors);

                    return true; // 验证通过
                }
                ),
            files: [],
            is_show_progress: false,
            all_tags:[],
            tag_remove_modal:false,
            handle_remove_tag_value:{//抓住準備要unbind的tag和creator
                row:null,
                tag:''
            },
            back_error_mag:{
                email:'',
                instagram_handle:'',
                tiktok_handle:'',
            }
        }
    },
    


    props: {
        isInline: {
            type: Boolean,
            default: false,
        }
    },

    methods: {
        formatBytes: formatBytes,

        handleSelectTag(item){
            this.handle_remove_tag_value.row=item.row;
            this.handle_remove_tag_value.tag=item.tag;
            this.tag_remove_modal=true;
        },

        update(obj) {
            this.is_error = false;
            this.error_msg = '';

            Object.keys(this.values).forEach(key => {
                if (key === obj.key) {
                    this.values[key] = obj.val.replace(/\s+$/, '');
                    obj.el.value = this.values[key];
                }
            });
        },

        submit() {
            //console.log(this.values);
            this.values.tiktok_handle = this.values.tiktok_handle.replace('@', '');
            this.error_msg = '';
            this.back_error_mag.email = '';
            this.back_error_mag.tiktok_handle = '';
            this.back_error_mag.instagram_handle = '';
            
            const data = {
                "total_row_count": 0,
                "new_creator_count": 0,
                "exist_creator_count": 0,
                "error_count": 0,
                "exist_creator_list":[],
                "new_creator_list":[]
            };

            const { tag_all_open, tag_open, tags, merchant_account_tags, ...newValues } = this.values;
            //後端用merchant_accounts_tag_ids接收
            this.values.merchant_accounts_tag_ids=merchant_account_tags.map(e=>{return e.id});
            console.log(newValues)
            this.is_loading = true;
            this.$ajax('/creator/create', {
                method: 'post',
                data: this.values,
            }).then(res => {
                data.new_creator_count = 1;
                // res.data.data.forEach(item => {
                //     console.log(item)
                //     // item.tiktok_handle = item.tiktok_handle.replace('@', '');
                // });
                //temp
                data.merchant_account_tags= merchant_account_tags;
                res.data.data.merchant_account_tags= merchant_account_tags;
                //----
                data.new_creator_list.push(res.data.data);
                this.$emit('add-creator', data);
                this.is_loading = false;
            }).catch(err => {
                this.is_loading = false;
                // console.log(err.response.data);

                if (err && err.response && err.response.data.data) {
                    this.is_error = true;
                    let er=err.response.data.data.creator_duplicate_status;
                    if (er.email_duplicate) {
                        this.back_error_mag.email = 'This email has already been added.';
                    } 

                    if(er.tiktok_duplicate) {
                        this.back_error_mag.tiktok_handle = 'This social handle has already been added.';
                    }

                    if(er.instagram_duplicate) {
                        this.back_error_mag.instagram_handle = 'This social handle has already been added.';
                    }
                     
                    if(!er.email_duplicate && !er.tiktok_duplicate && !er.instagram_duplicate){ 
                        this.error_msg = err.response.data.data.message;
                    }
                }

            });
            // console.log(this.values)
            // /api/v1/creator/create
            // this.$emit('add-creator', this.values);
        },
        
        frame() {
            if (this.progress >= 99) {
                window.clearInterval(this.interval);
            } else {
                this.progress ++;
            }
        },

        uploadFile() {
            // console.log(this.$refs.upload, this.$refs.upload.active)
            this.is_show_progress = true;
            this.interval = window.setInterval(this.frame, 30);
            let form_data = new FormData();

            form_data.append('creator_list_file', this.files[0].file);

            this.$ajax(`/creator/import-file`, {
                method: 'post',
                data: form_data,
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(res => {
                window.clearInterval(this.interval);
                this.progress = 100;
                res.data.data.new_creator_list.forEach(item => {
                    if (item.first_name === null) item.first_name = '';
                    if (item.last_name === null) item.last_name = '';
                    if (item.email === null) item.email = '';
                    if (item.status_text === -2 || item.status_text === -3) item.status_text = 'Pending';
                    if ( !item.merchant_account_tags) item.merchant_account_tags = [];
                });
                this.upload_data = res.data.data;
            }).catch(err => {
                console.log(err.response);
                this.is_file_error = true;
                this.file_error_msg = err.response.data && err.response.data.data ?err.response.data.data.message:"";

            });
            
            // setTimeout(() => {
            //     this.$refs.upload.active = true;
            // }, 600);
        },

        cancelUpload() {
            this.progress = 0;
            this.is_file_error = false;
            this.file_error_msg = '';
            this.is_show_progress = false;
            this.$refs.upload.active = false;
            this.files = [];
        },

        doneUpload() {
            // this.xlsxToJson();
            this.is_show_list = true; 
            this.is_show_progress = false;
            // this.$refs.upload.active = false;
            this.files = [];
            this.$emit('add-creator', this.upload_data);

            // this.upload_data.exist_creator_list.forEach(item => {
            //     item.is_exist = true;
            //     this.$emit('add-creator', item);
            // });

            // this.upload_data.new_creator_list.forEach(item => {
            //     this.$emit('add-creator', item);
            // });
        },


        // xlsxToJson() {
        //     // Instantiate the read file to object 
        //     // https://developer.mozilla.org/zh-CN/docs/Web/API/FileReader
        //     const self = this;
        //     const fileReader = new FileReader();
        //     self.data = [];
        //     fileReader.onload = function(event) {
        //         let data = event.target.result;
        //         let workbook = XLSX.read(data, {
        //             type: 'binary'
        //         });

        //         workbook.SheetNames.forEach(sheet => {
        //             let rows = XLSX.utils.sheet_to_row_object_array(
        //                 workbook.Sheets[sheet]
        //             );

        //             // console.log(rows)
                    
        //             // let json_str = JSON.stringify(rows);
        //             let count = 0;

        //             rows.forEach((item, index) => {
        //                 if (item['Creator Last Name'] && item['Creator First Name']) {
        //                     const data = {
        //                         first_name: item['Creator First Name'],
        //                         last_name: item['Creator Last Name'],
        //                         tiktok_handle: item['TikTok'] ? item['TikTok'] : '',
        //                         instagram_handle: item['Instagram'] ? item['Instagram'] : '',
        //                         profile: item['Onboard Status'] ? item['Onboard Status'] : '',
        //                     }
        //                     count ++;
        //                     self.$emit('add-creator', data);
        //                 }
        //             });
                    
        //             if (count === 0) self.$emit('no-data', data);
        //             self.files = [];
        //         });
        //     };

        //     fileReader.readAsBinaryString(this.files[0].file);
        // },
        //這邊會處理單人的tag刪減增加,API處理會在元件裡面做完(除了有spec_text的要另外CALL)
        selectTag(item,spec_text){
            selectTag( item, spec_text, this ,'adding'); 
        },

    },
    
    async mounted(){
        let tagData= await getTags(this);
        if(tagData.data){
            this.all_tags=tagData.orgData;
        }
        handleCreTag(this.values, this.all_tags);
    }
}
</script>
<style lang="scss">
    .add-partner {
        padding: 16px 0;

        .or {
            font: var(--font-fg-20);
            margin: 12px 0;
        }

        .disabeld-box{
            opacity: .5;
        }

        .form-wrap {
            border-radius: 8px;
            border: 1px solid white;
            background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='6' ry='6' stroke='%23bdbdbd' stroke-width='2' stroke-dasharray='8%2c 12' stroke-dashoffset='5' stroke-linecap='square'/%3e%3c/svg%3e");
            width: 100%;
            margin: 12px 0;
            padding: 28px;
            display: grid;
            gap: 8px;

            &.is-loading {
                opacity: .5;
                pointer-events: none;
            }

            &.is-error {

                .el-input .el-input--wrap select, 
                .el-input .el-input--wrap input, 
                .el-input .el-input--select select, 
                .el-input .el-input--select input,
                .el-input .el-input--icon-wrap {
                    border-color: var(--alert) !important;
                }

                .error-msg {
                    margin: 4px 0 0;
                    font-size: 12px;
                    color: var(--alert);

                    &::before {
                        content: '*';
                    }
                }
            }
            .err-input{
                border: solid 1px var(--alert) !important;
                border-radius: 6px;
            }

            .error-msg {
                margin: 4px 0 0;
                font-size: 12px;
                color: var(--alert);
                text-align: right;
                display: flex;
                align-items: center;
                justify-content: flex-end;

                &::before {
                    content: '*';
                }

                .svg-icon {
                    margin-left: 4px;
                    width: 12px;
                    height: 12px;
                }
            }

            .program-tag-box-big{
                position:relative;
                label{
                    &:after{
                        display:none;
                    }
                }
            }

            //tag css
            .add-tag-btn{
                padding: 4px;
                border:solid 1px var(--neutral);
                border-radius:6px;
                height: 24px;
                display: flex;
                align-items: center;

                .svg-icon{
                    margin: unset;
                    width: 14px;
                }
            }

            .my-badges-iden{
                display:flex;
                align-items: center;
                border-radius: 6px;
                svg {
                    height: 8px;
                    width: 8px;
                    margin-left: 6px;
                }

                span{
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    max-width: 100px;
                    background:unset;
                    display:unset;
                    height: unset;
                    padding: unset;
                }
            }

            .program-tag-box {
                border-radius: 6px;
                margin: 8px 0 0;
                display: flex;
                align-items: center;
                position:relative;

                dl {
                    display: flex;
                    align-items: center;
                    width:100%;
                }

                dt {
                    font: var(--font-med-14);
                    color: var(--black-90);
                    display: flex;
                    align-items: center;
                    
                    svg {
                        width: 20px;
                        height: 20px;
                        fill: var(--black-90);
                        margin-right: 6px;
                    }
                }

                dd {
                    padding-left: 12px;
                    display: flex;
                    align-items: center;

                    span {
                        display: inline-flex;
                        height: 24px;
                        border-radius: 4px;
                        background-color: white;
                        padding: 0 6px;
                        align-items: center;
                        font-size: 12px;
                    }


                    &.program-tag-box-dd{
                        cursor:pointer;
                        display:flex;
                        align-items: center;
                        flex-wrap: wrap;
                        padding:4px;
                        gap:6px;
                        margin-left:0px;
                        flex:1;
                        background-color: var(--white);

                        &.edit-program-tag-box-dd{
                            border:solid 1px var(--neutral);
                            border-radius:6px;
                        }

                        .my-badges-iden{
                            display:flex;
                            align-items: center;
                            border-radius: 6px;
                            svg {
                                height: 8px;
                                width: 8px;
                                margin-left: 6px;
                            }

                            span{
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                                max-width: 100px;
                                background:unset;
                                display:unset;
                                height: unset;
                                padding: unset;
                            }
                        }

                        .add-tag-btn{
                            padding: 4px;
                            border:solid 1px var(--neutral);
                            border-radius:6px;
                            height: 24px;
                            display: flex;
                            align-items: center;

                            .svg-icon{
                                margin: unset;
                                width: 14px;
                            }
                        }
                    }
                }
            }

            //
            .two-field {
                display: flex;
                margin-bottom: 10px;

                .item {
                    width: 50%;

                    &:first-child {
                        padding-right: 4px;
                    }

                    &:last-child {
                        padding-left: 4px;
                    }
                }
            }

            .label {
                font: var(--font-demi-14);
                color: var(--dark-blue);

                &:after {
                    content: ' *';
                    color: var(--alert);
                }
            }

            .label-sub{
                font: var(--font-demi-14);
                color: var(--text-secondary);
            }

            .desc {
                font-size: 12px;
                color: var(--black-75);
                margin-bottom: 8px;
            }

            .el-input {
                margin: 8px 0 0;
            }

            .el-input__prefix-inner{
    
                color: var(--black-100);
            }

            .el-input--icon-wrap .befter-icon {
                margin-left: 10px;
            }

            .el-input--icon-wrap input,
            .el-input--wrap input {
                padding: 12px 10px;
            }

            .el-input--icon-wrap .befter-text + input {
                padding-left: 0;
            }

            .btn-wrap {
                display: flex;
                justify-content: flex-end;
                align-items: center;
                margin-top: 16px;

                p {
                    flex: 1;
                    font-size: 12px;
                    display: flex;
                    align-items: center;

                    a {
                        text-decoration: underline;
                        margin-left: 5px;

                        &:hover {
                            text-decoration: none;
                        }
                    }
                }

                .ui-button {
                    width: 110px;
                    text-align: center;
                }
            }

            &.upload-form {

                .drop-active {
                    position: fixed;
                    left: 0;
                    top: 0;
                    height: 100%;
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background-color: rgba(#000, .65);
                    color: var(--black-10);
                    z-index: 99999999999999;

                    h3 {
                        font: var(--font-fg-18);
                    }
                }

                .btn-wrap {

                    .ui-button {
                        // width: 160px;
                        display: flex;
                        width: auto;
                        align-items: center;

                        svg {
                            margin-right: 8px;
                        }
                    }
                }
            }

            .file-uploads {
                display: block;
                cursor: pointer;

                & > label {
                    cursor: pointer;
                }
            }

            .empty-box {
                display: flex;
                align-items: center;
                margin-bottom: 0;
                cursor: pointer;

                img {
                    width: 148px;
                    display: block;
                }

                p {
                    margin-left: 16px;
                    color: var(--dark-blue);
                    text-align: left;
                    font: var(--font-fg-16);

                    a {
                        color: var(--blue);
                        text-decoration: underline;
                    }
                }

                svg {
                    width: 56px;
                    height: 56px;
                    fill: var(--black-40);
                }
            }

            .file-list {
                margin-bottom: 12px;

                .item {
                    display: flex;
                    align-items: center;
                    padding: 0 16px 0 0;
                    background-color: white;

                    .ico {
                        width: 55px;
                        height: 55px;

                        img {
                            height: 100%;
                            width: 100%;
                            display: block;
                        }
                    }

                    .meta {
                        flex: 1;
                        padding: 8px;

                        .name {
                            font: var(--font-fg-12);
                            color: var(--black-90);
                        }

                        .size {
                            font-size: 12px;
                            color: var(--black-60);

                            &::after {
                                content: ' ready';
                            }
                        }
                    }

                    .remove {
                        height: 32px;
                        width: 32px;
                        cursor: pointer;

                        svg {
                            fill: none;
                            height: 100%;
                            width: 100%;
                            display: block;
                        }

                    }
                }
            }
        }
    }

    .progress-modal {
        .ui-modal--container {
            width: 460px;
        }

        .box {
            padding: 24px 32px 32px;

            p {
                margin: 0 0 14px;

                strong {
                    font-weight: 600;
                }

                // & + div {
                //     height: 8px;
                // }
            }

            .progress {
                height: 8px;
                background-color: var(--black-10);
                position: relative;

                .progress-bar {
                    height: 100%;
                    position: absolute;
                    left: 0;
                    background-color: var(--bg-09);
                    transition: .1s width ease;
                }
            }

            .error-text {
                color: var(--alert);
            }
            
            .btn {
                display: flex;
                align-items: center;
                margin-top: 16px;
                font: var(--font-fg-14);

                .text {
                    flex: 1;
                    color: var(--dark-blue);
                }


                .ui-button {
                    width: 180px;
                    text-align: center;
                }
            }
        }

    }
</style>

